var React = require('react');

function CircleCrossInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"18","cy":"18","r":"18","fill":"#00114D","key":0}),React.createElement("line",{"x1":"14.5146","y1":"21.5858","x2":"21.5857","y2":"14.5147","stroke":"white","strokeWidth":"2","strokeLinecap":"round","key":1}),React.createElement("line",{"x1":"14.414","y1":"14.5148","x2":"21.485","y2":"21.5858","stroke":"white","strokeWidth":"2","strokeLinecap":"round","key":2})]);
}

CircleCrossInline.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = CircleCrossInline;

CircleCrossInline.default = CircleCrossInline;
